import axios from "axios";

const createWebpageCategory = async (formdata) => {
    const response = await axios.post('/api/content/create-webpage-category', formdata);
    return response.data;
}
const updateCategory = async(formdata) =>{
    const response = await axios.post('/api/content/update-category',formdata);
    return response.data;
}
const updateCategoryMeta = async (formdata) =>{
    const response = await axios.post('/api/content/update-category-meta',formdata);
    return response.data;
}

const getCategories = async(projectId) =>{
    const formdata = {
        projectId : projectId
    }
    const response = await axios.post('/api/content/get-categories',formdata);
    return response.data;
}

const getPaginatedCategories = async(projectId, activePage, recordsPerPage) =>{
    const formdata = {
        projectId : projectId,
        activePage : activePage,
        records : recordsPerPage
    }
    const response = await axios.post('/api/content/get-paginated-categories',formdata);
    return response.data;
}

const getTaxonomies = async(formdetails,projectId,activePage, records) => {
    const formdata = {
        formdetails,
        projectId : projectId,
        activePage, 
        records
    }
    const response = await axios.post('/api/content/get-taxonomies',formdata);
    return response.data;
}
const getCategoryDetails= async(categoryId) =>{
    const formdata = {
        categoryId : categoryId
    }
    const response = await axios.post('/api/content/get-category-details',formdata);
    return response.data;
}

const reorderCategories = async(formdata) =>{
    const response = await axios.post('/api/content/reorder-categories',formdata);
    return response.data;
}
const removeCategory = async(formdata) =>{
    const response = await axios.post('/api/content/remove-category',formdata);
    return response.data;
}
const deleteCategory = async(formdata) =>{
    const response = await axios.post('/api/content/delete-category',formdata);
    return response.data;
}

const restoreCategory = async(formdata) =>{
    const response = await axios.post('/api/content/restore-category',formdata);
    return response.data;
}

const getArticles = async(projectId,formdetails,page,records) =>{
    const formdata = {
        projectId : projectId,
        filters : formdetails,
        page : page,
        records : records
    }
    const response = await axios.post('/api/content/get-articles',formdata);
    return response.data;
}

const getTotalArticles = async(projectId, formdetails) =>{
    const formdata = {
        projectId : projectId,
        filters : formdetails
    }
    const response = await axios.post('/api/content/get-total-articles',formdata);
    return response.data;
}

const deleteArticle = async(articleId,projectId) =>{
    const formdata = {
        articleId : articleId,
        projectId : projectId
    }
    const response = await axios.post('/api/content/delete-article',formdata);
    return response.data;
}

const restoreArticle = async(articleId,projectId) =>{
    const formdata = {
        articleId : articleId,
        projectId : projectId
    }
    const response = await axios.post('/api/content/restore-article',formdata);
    return response.data;
}

const getDailyInsertedArticles = async(projectId) =>{
    const formdata = {
        projectId : projectId
    }
    const response = await axios.post('/api/content/get-daily-inserted-articles',formdata);
    return response.data;
}

const getArticlesTypeCount = async(projectId) =>{
    const formdata = {
        projectId : projectId
    }
    const response = await axios.post('/api/content/get-articles-type-count',formdata);
    return response.data;
}
const getWPWebstories =  async(filters,page,records) =>{
    const formdata = {
        filters,
        page,
        records
    }
    const response = await axios.post('/api/content/get-wp-webstories',formdata);
    return response.data;
}

const getArticleDetail = async(data)=>{
    const response = await axios.post('/api/content/get-article-details', data);
    return response.data;
}

const resyncArticle = async (data)=>{
    const response = await axios.post('/api/content/resync-article',data);
    return response.data;
}

const getAllCategoriesList = async (projectId) => {
    const formdata = { projectId };
    const response = await axios.post('/api/content/get-all-categories-list', formdata);
    return response.data;
};

const getTaxonomyTypesList = async (projectId) => {
    const formdata = { projectId };
    const response = await axios.post('/api/content/get-taxonomy-types-list', formdata);
    return response.data;
};

const updateGamesStatus = async (formdata) => {
    const response = await axios.post('/api/content/update-games-status', formdata);
    return response.data;
}

export  default {
    createWebpageCategory,
    getCategories,
    getCategoryDetails,
    updateCategory,
    updateCategoryMeta,
    reorderCategories,
    removeCategory,
    deleteCategory,
    restoreCategory,
    getPaginatedCategories,
    getArticles,
    getTotalArticles,
    deleteArticle,
    restoreArticle,
    getDailyInsertedArticles,
    getArticlesTypeCount,
    getWPWebstories,
    getArticleDetail,
    resyncArticle,
    getTaxonomies,
    updateGamesStatus,
    getAllCategoriesList,
    getTaxonomyTypesList,
}